import React from 'react';
import classNames from 'classnames';
import Button, { ButtonProps } from './Button';

const SelectableButton = React.forwardRef<any, ButtonProps>(({ className, children, ...rest }, ref) => (
  <Button className={classNames(className, 'selectable')} {...rest} ref={ref}>
    {children}
  </Button>
));

export default SelectableButton;
